<script>
export default {
  name: 'WebCall',
  components: {},
  props: {
    token: {
      type: String,
      required: true,
    },
    componentData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div :class="$style.container"/>
</template>


<style lang="scss" scoped module>
@import '@design';

.container {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: space-around;
  min-height: 100vh;
  max-height: 100vh;
}
</style>
